import createDOMPurify from 'dompurify';

const DOMPurify = createDOMPurify(window);

export default DOMPurify;
